import {
  Alert,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tabs,
  Tag,
  Typography,
  message,
} from "antd"
import React, { useEffect, useState } from "react"
import "./CreateInvoice.css"
import { useCollection } from "../../../hooks/useCollection"
import { EyeOutlined, InfoCircleOutlined, PieChartOutlined, UserOutlined } from "@ant-design/icons"
import { db } from "../../../firebase/config"
import {
  Timestamp,
  addDoc,
  arrayUnion,
  collection,
  deleteField,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore"
import { languageOpts } from "../Generate/Translation"
import { generateInvoice } from "../Generate/GenerateInvoice"
import { loadingSpinWithBg } from "../../../components/Elements/LoadingSpinner"
import { useAuthContext } from "../../../hooks/useAuthContext"
import moment from "moment/moment"
import ProductsAndServices from "./ProductsAndServices"
import { generatePackingList } from "../Generate/GeneratePackingList"
import dayjs from "dayjs"
import {
  englishPackingListTranslations,
  latvianPackingListTranslations,
} from "../Generate/PLTranslation"
import { getBaseComment } from "./getBaseComment"
import { getAvailableBankAccounts } from "../../../utils/getBankAccountDetails"

const { Text, Link, Paragraph } = Typography
const { TextArea } = Input

// Helper function to format a Date as "DD.MM.YYYY"
function formatDate(date) {
  const dd = String(date.getDate()).padStart(2, "0")
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const yyyy = date.getFullYear()
  return `${dd}.${mm}.${yyyy}`
}

// Create native Date objects
const today = new Date()
const twoWeeksTs = Timestamp.fromDate(new Date(new Date().getTime() + 14 * 24 * 60 * 60 * 1000))

//init object for the whole invoiceR
const initObject = {
  clientId: null,
  client: {
    client: "none",
    id: null,
    clientGroup: null,
    vat: null,
    reg: null,
  },
  manufacturer: {
    company: "none",
  },
  documentDate: today, // Use today's date
  created: today,
  pdfDate: today, //  today
  clientDeliveryAddress: null,
  manufacturerDeliveryAddress: null,
  payUntil: twoWeeksTs,
  payUntilFormatted: formatDate(twoWeeksTs.toDate()),
  commentText: "",
  documentFor: "clientPickup",
  resaleInvoice: false,
  invoiceDate: today,
  docType: "invoice",
  documentForComment: "",
  prices: [
    {
      key: 1,
      code: 0,
      product: null,
      unit: "thous.",
      count: 0,
      price: 0.0,
      sum: 0,
      vat: 0,
      dAccount: 2310,
      dName: "Norēķini ar pircējiem un pasūtītājiem",
      dCurrency: "Eur",
      cAccount: 6110,
      cName: "Ieņēmumi no pamatdarbības produkcijas un pakalpojumu pārdošanas",
      kCurrency: "Eur",
      productComment: "",
      hasProductComment: false,
      hasManualCount: false,
      hasChangableSpace: false,
    },
  ],
  currency: "Eur",
}

export default function CreationForm(props) {
  //if comes from a drawer content
  const {
    fromDrawer,
    objectFromDrawer,
    extractedClient,
    extractedManufacturer,
    selectedRowKeys = [],
    setOpen,
    resetRows,
    forProforma,
    hasProformas,
    proformasData,
    setShowWeight,
    showWeight,
    editingInvoiceData, // << NEW: The full invoice object if editing
    onSuccess, // << NEW: Callback for successful creation/update
  } = props

  //gets user document
  const { user, admin } = useAuthContext()

  const [clientData, setClientData] = useState([])
  const [clientLoading, setClientLoading] = useState(false)

  const isEditing = !!editingInvoiceData

  //document type
  const documentTypeBasedOnDrawer = forProforma ? "proforma" : "invoice"
  const [documentType, setDocumentType] = useState(documentTypeBasedOnDrawer)

  // handles the avaiable client list
  useEffect(() => {
    setClientLoading(true)
    let ref = collection(db, "clients")
    let q

    if (admin) {
      // if admin, gets all the clients
      q = query(ref)
    } else if (user) {
      //if basic user, gets only their clients
      q = query(ref, where("user", "==", user.uid))
    }

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ ...doc.data(), id: doc.id })
      })
      //sets list
      setClientData(results)
      //sets loading
      setClientLoading(false)
    })

    return () => unsubscribe()
  }, [user, admin])

  //fetch manufacturers
  const { data: manufacturerData, loading: manufacturerLoading } = useCollection("manufacturers")

  //global loading (sends a page into loading state when the pdf is generating)
  const [globalLoading, setGloabalLoading] = useState(false)

  //drawer
  const [drawerOpen, setDrawerOpen] = useState(false)

  //client data check
  const [doesClientNeedUpdate, setDoesClientNeedUpdated] = useState(false)

  //the clients keys that require the update
  const [clientKeysToUpdate, setClientKeysToUpdate] = useState({})

  //should a button be disabled ?
  const [disabledButton, setDisabledButton] = useState(true)

  //init form
  const [form] = Form.useForm()
  const [updateClientForm] = Form.useForm()

  //initial invoice object
  const [invoiceData, setInvoiceData] = useState(initObject)

  //available products
  const [availableProducts, setAvailableProducts] = useState(null)
  const [productsLoading, setProductsLoading] = useState(false)

  //available product counts
  const [productCount, setProductCounts] = useState([])

  //deliery options for client
  const [deliveryOptions, setDeliveryOptions] = useState([
    {
      deliveryAddress: null,
    },
    {
      deliveryAddress: null,
    },
  ])

  //language
  const [selectedLanguage, setSelectedLanguage] = useState("Latvian")
  const [selectedTranslation, setSelectedTranslation] = useState(languageOpts[0])

  //delivery options for manufacturer
  const [manufacturerDelivery, setManufacturerDelivery] = useState([
    {
      deliveryAddress: null,
      deliveryCity: null,
      deliveryPC: null,
    },
  ])

  //totals data
  const [totalsData, setTotalsData] = useState({
    totalProfitDiscount: 0,
    totalNetoSum: 0,
    totalVat: 0,
    totalSum: 0,
  })

  const [count, setCount] = useState(2)

  //checks if the document is for printing or something else
  const [docForPrinting, setDocForPrinting] = useState(true)
  const [documentFor, setDocumentFor] = useState("clientPickup")

  const [isCreditInvoice, setIsCreditInvoice] = useState(false)
  const [selectedCreditInvoice, setSelectedCreditInvoice] = useState(null)
  const [availableInvoices, setAvailableInvoices] = useState([])

  // Bank account selection
  const [selectedManufacturerBankAccountIndex, setSelectedManufacturerBankAccountIndex] = useState(0)
  const [selectedClientBankAccountIndex, setSelectedClientBankAccountIndex] = useState(0)
  const [loadingInvoices, setLoadingInvoices] = useState(false)
  const [creditInvoiceData, setCreditInvoiceData] = useState({})

  // Fetch available invoices when manufacturer is selected
  useEffect(() => {
    const fetchInvoicesForManufacturer = async () => {
      if (!invoiceData.manufacturer?.id || !isCreditInvoice) {
        setAvailableInvoices([])
        return
      }

      setLoadingInvoices(true)
      try {
        const invoicesRef = collection(db, "invoices")
        const q = query(
          invoicesRef,
          where("manufacturer.id", "==", invoiceData.manufacturer.id),
          where("docType", "==", "invoice"),
          where("deleted", "==", false),
        )

        const querySnapshot = await getDocs(q)
        const invoices = []
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          invoices.push({
            id: doc.id,
            label: `${data.docPrefix}${String(data.docNumber).padStart(4, "0")} - ${
              data.client.client
            } - ${data.totalData.totalSum.toFixed(2)} EUR`,
            value: doc.id,
            ...data,
          })
        })

        // Sort by date, newest first
        invoices.sort((a, b) => {
          const dateA = a.documentDate?.toDate() || new Date(0)
          const dateB = b.documentDate?.toDate() || new Date(0)
          return dateB - dateA
        })

        setAvailableInvoices(invoices)
      } catch (error) {
        console.error("Error fetching invoices:", error)
        message.error("Failed to load invoices")
      } finally {
        setLoadingInvoices(false)
      }
    }

    fetchInvoicesForManufacturer()
  }, [invoiceData.manufacturer?.id, isCreditInvoice])

  //swaps if docForPrinting is true based on location
  useEffect(() => {
    if (fromDrawer) {
      setDocForPrinting(true)
    } else {
      setDocForPrinting(false)
    }
  }, [fromDrawer])

  // Initialize bank account indices when editing
  useEffect(() => {
    if (editingInvoiceData) {
      setSelectedManufacturerBankAccountIndex(editingInvoiceData.selectedManufacturerBankAccountIndex ?? 0)
      setSelectedClientBankAccountIndex(editingInvoiceData.selectedClientBankAccountIndex ?? 0)
    }
  }, [editingInvoiceData])

  // Handle credit invoice selection
  const handleCreditInvoiceSelect = (invoiceId) => {
    const selected = availableInvoices.find((inv) => inv.id === invoiceId)
    if (selected) {
      setSelectedCreditInvoice(invoiceId)
      setCreditInvoiceData({
        creditInvoiceId: selected.id,
        creditInvoiceCode: `${selected.docPrefix}${String(selected.docNumber).padStart(4, "0")}`,
        creditInvoiceTotalNeto: selected.totalData.totalNetoSum,
        creditInvoiceTotalVat: selected.totalData.totalVat,
        creditInvoiceTotalSum: selected.totalData.totalSum,
      })
    }
  }

  // Handle checkbox change
  const handleCreditInvoiceToggle = (checked) => {
    setIsCreditInvoice(checked)
    if (!checked) {
      setSelectedCreditInvoice(null)
      setCreditInvoiceData({})
    }
  }

  // --------------- PACKING LIST CREATION ---------------
  // Generate + save packing list, return the packingListURL
  const createAndSavePackingList = async () => {
    // read the 'packingList' doc from "sequence"
    const sequenceRef = doc(db, "sequence", "packingList")
    const sequenceSnapshot = await getDoc(sequenceRef)
    if (!sequenceSnapshot.exists()) {
      throw new Error("No packingList sequence doc found!")
    }
    const currentPLNumber = sequenceSnapshot.data().lastPackingListNumber || 0
    const newPLNumber = currentPLNumber + 1

    // Build the data object for the packing list
    const senderAddress = [
      invoiceData.manufacturer.legalAddress,
      invoiceData.manufacturer.legalCity,
      invoiceData.manufacturer.legalPC,
    ]
      .filter(Boolean)
      .join(", ")

    const packingListData = {
      packingListNumber: `PL-${newPLNumber}`,
      date: new Date(),
      sender: {
        senderCompany: invoiceData.manufacturer.company || "No company name",
        senderReg: invoiceData.manufacturer.reg || "No company reg",
        senderVat: invoiceData.manufacturer.vat || "No company vat",
        senderLegalAddress: invoiceData.manufacturer.legalAddress || "No company legal address",
        senderDeliveryAddress: senderAddress,
      },
      receiver: {
        receiverCompany: invoiceData.client.client || "Unknown client",
        receiverReg: invoiceData.client.reg || "Unknown reg number",
        receiverVat: invoiceData.client.vat || "Unknown vat number",
        receiverLegalAddress: invoiceData.client.legalAddress || "Unknown legal address",
        receiverDeliveryAddress: invoiceData.clientDeliveryAddress || "Unknown delivery address",
      },
      products: invoiceData.prices.map((item, idx) => ({
        name: item.product || `Item #${idx + 1}`,
        quantity: item.count || 0,
        weight: item.weight || 0,
        boxesCount: item.boxesCount || 0,
      })),
      // We'll reuse invoiceData.documentForComment as comment
      comment: invoiceData.documentForComment || "",
    }

    //language for translation
    let packingListTranslation =
      selectedLanguage === "English"
        ? englishPackingListTranslations
        : latvianPackingListTranslations

    //  generate packing list
    const packingListURL = await generatePackingList(packingListData, packingListTranslation)

    // update Firestore doc: increment lastPackingListNumber
    await updateDoc(sequenceRef, {
      lastPackingListNumber: newPLNumber,
      updated: serverTimestamp(),
    })

    return packingListURL
  }

  // Add handler for product type change
  const handleProductTypeChange = (key, value, productData, setInvoiceData, invoiceData) => {
    const updatedProductData = productData.map((item) => {
      if (item.key === key) {
        // Construct new product name with selected type
        const baseProductName = item.productName || ""
        const newProductName = value ? `${value} ${baseProductName}` : baseProductName

        return {
          ...item,
          productType: value,
          product: newProductName,
        }
      }
      return item
    })

    setInvoiceData({
      ...invoiceData,
      prices: updatedProductData,
    })
  }

  // --------------- INVOICE CREATION ---------------
  const createInvoice = async (object) => {
    setGloabalLoading(true)
    console.log("1.loading set")

    // prefix
    let docPrefix = object.manufacturer.invoicePrefix
    console.log("2.prefix bypassed", docPrefix)

    try {
      // Get the current sequence number
      const sequenceRef = doc(db, "sequence", docPrefix)
      const sequenceSnapshot = await getDoc(sequenceRef)
      const currentNumber = sequenceSnapshot.data().lastInvoiceNumber
      const currentHronoId = sequenceSnapshot.data().lastHronoId

      console.log("3.sequence gotten")

      // Build invoice data with sequence
      const invoiceWithSequence = {
        docNumber: currentNumber + 1,
        hronodId: currentHronoId + 1,
        docPrefix,
        user: user.email,
        userId: user.uid,
        docType: documentType,
        deliveryMethod: documentFor,
        totalData: totalsData,
        createdTimestamp: serverTimestamp(),
        pdfLanguage: selectedLanguage,
        ...object,
      }

      // Generate invoice PDF
      const generatedUrl = await generateInvoice(
        invoiceWithSequence,
        selectedLanguage,
        selectedTranslation,
        documentType,
        hasProformas,
        proformasData,
        object.isCreditInvoice || false,
        object.creditInvoiceData || {},
        selectedManufacturerBankAccountIndex,
        selectedClientBankAccountIndex,
      )
      if (!generatedUrl) {
        throw new Error("Invoice URL was not generated.")
      }
      console.log("5.file url bypassed", invoiceWithSequence)

      // If this invoice has proformas, the proforma was already paid
      // (orders can't proceed without proforma payment), so set paidAmount immediately.
      const invoiceTotal = totalsData?.totalSum || 0
      const proformaAdvance =
        hasProformas && proformasData?.proformasTotalSum ? proformasData.proformasTotalSum : 0
      const initialPaidAmount = proformaAdvance
      const initialPaymentStatus =
        proformaAdvance > 0 ? (initialPaidAmount >= invoiceTotal ? 2 : 3) : 0

      // Build initial payments array if proforma advance exists
      const initialPayments =
        proformaAdvance > 0
          ? (proformasData.proformasCodes || []).map((code) => ({
              amount: proformasData.proformasTotalSum / (proformasData.proformasCodes?.length || 1),
              date: new Date(),
              note: `Proforma ${code} advance`,
              recordedBy: user?.uid || "",
              recordedAt: new Date(),
            }))
          : []

      // Create a complete object for Firestore
      const completeInvoiceData = {
        downloadUrl: generatedUrl,
        ...invoiceWithSequence,
        customInvoice: !docForPrinting,
        invoiceUsed: docForPrinting,
        paymentStatus: initialPaymentStatus,
        paidAmount: initialPaidAmount,
        ...(initialPayments.length > 0 ? { payments: initialPayments } : {}),
        deleted: false,
        orderReferenceId: fromDrawer ? selectedRowKeys : [],
      }

      console.log("6.File creation with download url bypassed")

      // Reference the invoices collection
      const invoicesCollectionRef = collection(db, "invoices")

      console.log("data", object)

      console.log("7.docrefBypassed")

      // Add the complete invoice/proforma to the DB and get its DocumentReference
      const invoiceDocRef = await addDoc(invoicesCollectionRef, completeInvoiceData)
      const newInvoiceId = invoiceDocRef.id
      console.log("9.added completed invoice/proforma to db with id:", newInvoiceId)

      // --- New logic for proforma references ---
      if (
        hasProformas &&
        proformasData &&
        proformasData.proformaIds &&
        proformasData.proformaIds.length > 0
      ) {
        // Update the newly created invoice doc with the array of proforma reference IDs
        await updateDoc(invoiceDocRef, {
          proformaReferenceIds: proformasData.proformaIds,
        })

        // For each proforma id, update its document by adding the new invoice id
        const updatePromises = proformasData.proformaIds.map(async (pid) => {
          const proformaRef = doc(db, "proformas", pid)
          await updateDoc(proformaRef, {
            // Append the new invoice id to the existing array (or create one)
            invoiceIds: arrayUnion(newInvoiceId),
            // Optionally, update the invoiceNumbers array using your invoice number format
            invoiceNumbers: arrayUnion(
              docPrefix + String(invoiceWithSequence.docNumber).padStart(4, "0"),
            ),
          })
        })
        await Promise.all(updatePromises)
        console.log("Proforma documents updated with new invoice references.")
      }

      if (object.isCreditInvoice && object.creditInvoiceData?.creditInvoiceId) {
        // Update the newly created invoice with credit reference
        await updateDoc(invoiceDocRef, {
          creditInvoiceReferenceId: object.creditInvoiceData.creditInvoiceId,
        })

        // Update the original invoice to show it has been credited
        const originalInvoiceRef = doc(db, "invoices", object.creditInvoiceData.creditInvoiceId)
        await updateDoc(originalInvoiceRef, {
          creditedBy: arrayUnion(newInvoiceId),
          creditInvoiceNumbers: arrayUnion(
            docPrefix + String(invoiceWithSequence.docNumber).padStart(4, "0"),
          ),
        })
        console.log("Credit invoice relationship established.")
      }

      // Update orders with invoice data including the new invoice ID
      if (fromDrawer) {
        const promises = selectedRowKeys.map(async (id) => {
          const orderRef = doc(db, "orders", id)
          return updateDoc(orderRef, {
            hasInvoice: true,
            invoiceAdded: serverTimestamp(),
            invoicePaymentStatus: 1,
            invoice: {
              invoiceUrl: generatedUrl,
              invoiceId: newInvoiceId, // Set the newly created invoice ID here
              created: serverTimestamp(),
              type: documentType,
              language: selectedLanguage,
              name: docPrefix + String(invoiceWithSequence.docNumber).padStart(4, "0"),
            },
          })
        })
        await Promise.all(promises)
        console.log("8.from drawer promise bypassed")
      }

      // Update the sequence document
      const updatedSequenceData = {
        lastInvoiceNumber: currentNumber + 1,
        lastHronoId: currentHronoId + 1,
        updated: serverTimestamp(),
        invoiceNumberBeforeLast: currentNumber,
        updatedBy: user.uid,
        docForPrinting: docForPrinting,
      }
      await updateDoc(sequenceRef, updatedSequenceData)
      console.log("10.sequence updated")

      // Download invoice PDF locally
      const link = document.createElement("a")
      link.href = generatedUrl
      link.download = "invoice.pdf"
      link.style.display = "none"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      message.success(`${documentType} created!`)

      // -------------- NEW LOGIC: If documentFor == "warehouseLogistics" => create packing list + send email --------------
      if (invoiceData.documentFor === "warehouseLogistics") {
        try {
          // a) Generate packing list
          const packingListURL = await createAndSavePackingList()

          // b) Update orders with hasPackingList and packingListUrl
          if (fromDrawer) {
            const promises = selectedRowKeys.map(async (id) => {
              const orderRef = doc(db, "orders", id)
              return updateDoc(orderRef, {
                hasPackingList: true,
                packingListUrl: packingListURL,
                updated: serverTimestamp(),
              })
            })
            await Promise.all(promises)
            console.log("Packing list updated on selected orders.")
          }

          // c) Call the cloud function to send both PDF attachments
          try {
            const emailFunctionUrl =
              "https://us-central1-managers-testing.cloudfunctions.net/sendDocsEmail"

            const response = await fetch(emailFunctionUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                invoiceUrl: generatedUrl, // Invoice link
                packingListUrl: packingListURL, // Packing list link
                contactEmail: "reinis.putans@gmail.com", // test email address
              }),
            })

            if (!response.ok) {
              const errorData = await response.json()
              throw new Error(
                errorData.error || `Email function call failed with status ${response.status}`,
              )
            }

            const result = await response.json()
            console.log("Cloud Function email result:", result)
            message.success("Email with invoice + packing list sent successfully!")
          } catch (emailError) {
            console.error("Error sending email via Cloud Function:", emailError)
            message.error("Failed to send email with invoice/packing list.")
          }
        } catch (plError) {
          console.error("Error generating packing list:", plError)
          message.error("Failed to generate packing list for warehouse logistics.")
        }
      }
      // ------------------------------------------------------------------------------

      setGloabalLoading(false)
    } catch (error) {
      message.error(`Error: ${error.message}`)
      console.log(error.message)
      setGloabalLoading(false)
    } finally {
      // Only call setOpen if it exists (when used from drawer)
      if (setOpen && typeof setOpen === "function") {
        setOpen(false)
        // Resets the row keys of the table
        resetRows()
      }
    }
  }

  // --------------- PROFORMA CREATION ---------------
  const createProforma = async (object) => {
    setGloabalLoading(true)
    console.log("1.loading set - proforma")

    // Prefix: add "PRO" to the manufacturer's invoicePrefix
    let docPrefix = "PRO" + object.manufacturer.invoicePrefix
    console.log("2.prefix bypassed", docPrefix)

    try {
      // Get the current sequence numbers for proforma
      const sequenceRef = doc(db, "sequence", docPrefix)
      const sequenceSnapshot = await getDoc(sequenceRef)
      const currentNumber = sequenceSnapshot.data().lastProformaNumber
      const currentHronoId = sequenceSnapshot.data().lastHronoId
      console.log("3.sequence gotten", currentNumber)

      // Build proforma data with sequence
      const proformaWithSequence = {
        docNumber: currentNumber + 1,
        hronodId: currentHronoId + 1,
        docPrefix,
        user: user.email,
        userId: user.uid,

        totalData: totalsData,
        deliveryMethod: documentFor,
        docType: documentType,
        createdTimestamp: serverTimestamp(),
        pdfLanguage: selectedLanguage,
        // Include other proforma data as needed
        ...object,
      }
      console.log(proformaWithSequence)

      // Generate the proforma PDF
      const generatedUrl = await generateInvoice(
        proformaWithSequence,
        selectedLanguage,
        selectedTranslation,
        documentType,
        false,
        [],
        false,
        {},
        selectedManufacturerBankAccountIndex,
        selectedClientBankAccountIndex,
      )
      if (!generatedUrl) {
        throw new Error("Proforma URL was not generated.")
      }
      console.log("5.file url bypassed - proforma", proformaWithSequence)

      // Create a complete object for Firestore
      const completeProformaData = {
        downloadUrl: generatedUrl,
        ...proformaWithSequence,
        invoiceIds: [],
        paymentStatus: 0,
        invoiceNumbers: [],
        proformaUsed: false,
        orderReferenceId: fromDrawer ? selectedRowKeys : [],
      }
      console.log("6.File creation with download url bypassed")

      // Reference the proformas collection
      let documentRef = collection(db, "proformas")
      console.log("7.docrefBypassed")

      // Add the complete proforma to the DB and capture its DocumentReference
      const proformaDocRef = await addDoc(documentRef, completeProformaData)
      const newProformaId = proformaDocRef.id
      console.log("9.added completed proforma to db with id:", newProformaId)

      // Update orders with proforma data including the new proforma ID
      if (fromDrawer) {
        const promises = selectedRowKeys.map(async (id) => {
          const orderRef = doc(db, "orders", id)
          return updateDoc(orderRef, {
            hasProforma: true,
            proformaAdded: serverTimestamp(),
            proformaPaymentStatus: 1,
            proforma: {
              proformaUrl: generatedUrl,
              proformaId: newProformaId, // Set the new proforma ID here
              created: serverTimestamp(),
              type: documentType,
              language: selectedLanguage,
              name: docPrefix + String(proformaWithSequence.docNumber).padStart(4, "0"),
            },
          })
        })
        await Promise.all(promises)
        console.log("8.from drawer promise bypassed")
      }

      console.log("complete proforma :", completeProformaData)

      // Update the sequence document
      const updatedSequenceData = {
        lastProformaNumber: currentNumber + 1,
        lastHronoId: currentHronoId + 1,
        updated: serverTimestamp(),
        proformaNumberBeforeLast: currentNumber,
        updatedBy: user.uid,
        docForPrinting: docForPrinting,
      }
      await updateDoc(sequenceRef, updatedSequenceData)
      console.log("10.sequence updated")

      // Download the proforma PDF locally
      const link = document.createElement("a")
      link.href = generatedUrl
      link.download = "invoice.pdf"
      link.style.display = "none"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      message.success(`${documentType} created!`)

      setGloabalLoading(false)
    } catch (error) {
      message.error(`Error: ${error.message}`)
      console.log(error.message)
      setGloabalLoading(false)
    } finally {
      // Only call setOpen if it exists (when used from drawer)
      if (setOpen && typeof setOpen === "function") {
        setOpen(false)
        // Resets the row keys of the table
        resetRows()
      }
    }
  }

  // New function to preview the document without saving to DB
  const previewDocument = async () => {
    setGloabalLoading(true)
    try {
      // Build a temporary invoice/proforma object for preview.
      // We use dummy sequence values (e.g. docNumber: 0) so that
      // this preview does not interfere with your actual sequence.
      const previewData = {
        ...invoiceData,
        docNumber: 0,
        hronodId: 0,
        // For proforma, prepend "PRO" to the prefix
        docPrefix:
          documentType === "proforma"
            ? "PRO" + invoiceData.manufacturer.invoicePrefix
            : invoiceData.manufacturer.invoicePrefix,
        user: user.email,
        userId: user.uid,
        docType: documentType,
        deliveryMethod: documentFor,
        totalData: totalsData,
        createdTimestamp: serverTimestamp(),
        pdfLanguage: selectedLanguage,
        // ADD CREDIT INVOICE DATA FOR PREVIEW
        ...(isCreditInvoice &&
          selectedCreditInvoice && {
            isCreditInvoice: true,
            creditInvoiceData: creditInvoiceData,
          }),
      }

      // Generate the PDF preview URL
      // IMPORTANT: Pass the credit invoice parameters to generateInvoice
      const previewUrl = await generateInvoice(
        previewData,
        selectedLanguage,
        selectedTranslation,
        documentType,
        hasProformas,
        proformasData,
        previewData.isCreditInvoice || false,
        previewData.creditInvoiceData || {},
        selectedManufacturerBankAccountIndex,
        selectedClientBankAccountIndex,
      )
      if (!previewUrl) {
        throw new Error("Preview generation failed.")
      }
      // Open the preview in a new tab (or you could show it in a modal)
      window.open(previewUrl, "_blank")
    } catch (err) {
      message.error(`Error generating preview: ${err.message}`)
    } finally {
      setGloabalLoading(false)
    }
  }

  //handles if the data is coming from the drawer
  useEffect(() => {
    form.resetFields() // Reset form fields initially
    if (isEditing && editingInvoiceData) {
      // POPULATE FORM FOR EDITING
      const {
        client,
        manufacturer,
        documentDate,
        payUntil,
        pdfLanguage,
        customInvoice,
        docType, // This should be fixed
        currency,
        clientDeliveryAddress,
        manufacturerDeliveryAddress,
        commentText,
        deliveryMethod,
        documentForComment,
        prices,
        id, // Store the ID of the invoice being edited
        docNumber, // Store original docNumber
        docPrefix, // Store original docPrefix
        hronodId, // Store original hronodId
        createdTimestamp, // Store original creation timestamp
        orderReferenceId, // Store original order references
        proformaReferenceIds, // Store original proforma references
        showWeightInComment: loadedShowWeightPref,
        // ... any other fields to pre-fill
      } = editingInvoiceData

      const initialCompanyAddress =
        client && client.street && client.city && client.postalCode
          ? `${client.street}, ${client.city}, ${client.postalCode}`
          : ""

      setInvoiceData({
        ...initObject, // Start fresh but ensure all fields exist
        ...editingInvoiceData, // Spread the original invoice data
        id, // Make sure ID is set
        docNumber,
        docPrefix,
        hronodId,
        createdTimestamp,
        orderReferenceId,
        proformaReferenceIds: Array.isArray(proformaReferenceIds) ? proformaReferenceIds : [],
        client: client || {},
        clientId: client?.id || null,
        manufacturer: manufacturer || {},
        prices: editingInvoiceData.prices
          ? editingInvoiceData.prices.map((p, idx) => {
              const originalStoredComment = p.productComment || ""
              // Use the item's specific weight for more accurate stripping
              const baseStoredComment = getBaseComment(originalStoredComment, p.weight)
              return {
                ...p,
                key: p.key !== undefined ? p.key : `edit-price-${idx}`,
                productComment: originalStoredComment, // For initial form field value if it's directly bound
                rawComment: baseStoredComment, // IMPORTANT: Ensure this is the CLEAN base
              }
            })
          : [],
        documentDate: documentDate, // Keep as Firestore Timestamp
        pdfDate: documentDate ? documentDate.toDate() : new Date(), // For DatePicker
        invoiceDate: documentDate ? documentDate.toDate() : new Date(), // For DatePicker field
        payUntil: payUntil, // Keep as Firestore Timestamp
        payUntilFormatted: payUntil
          ? formatDate(payUntil.toDate())
          : formatDate(twoWeeksTs.toDate()),
        commentText: commentText || "",
        documentFor: deliveryMethod || "clientPickup",
        docType: docType || "invoice",
        documentForComment: documentForComment || "",
        pdfLanguage: pdfLanguage || "Latvian",
        customInvoice: customInvoice === undefined ? true : customInvoice, // Default if undefined
        currency: currency || "Eur",
        showWeightInComment:
          typeof loadedShowWeightPref === "boolean" ? loadedShowWeightPref : false,
        clientsCompanyAddress: initialCompanyAddress,
      })

      form.setFieldsValue({
        client: client?.client,
        manufacturer: manufacturer?.company,
        invoiceDate: documentDate ? dayjs(documentDate.toDate()) : dayjs(),
        payUntil: payUntil ? dayjs(payUntil.toDate()) : dayjs(twoWeeksTs.toDate()),
        language: pdfLanguage || "Latvian",
        whatForDoc: customInvoice === false, // true for "Printing", false for "Custom"
        docType: docType || "invoice", // This select should be disabled
        currency: currency || "Eur",
        receiverAddress: clientDeliveryAddress,
        pickupAddress: manufacturerDeliveryAddress,
        comment: commentText,
        documentFor: deliveryMethod,
        documentForComment: documentForComment,
        clientsCompanyAddress: initialCompanyAddress,
      })

      if (editingInvoiceData.prices && editingInvoiceData.prices.length > 0) {
        // Find the highest existing key in the prices array
        const highestKey = Math.max(...editingInvoiceData.prices.map((p) => p.key || 0))
        // Set the counter to one higher than the highest existing key
        setCount(highestKey + 1)
      } else {
        // If there are no existing products, just reset the counter to a safe default
        setCount(1)
      }

      setSelectedLanguage(pdfLanguage || "Latvian")
      const langOpt = languageOpts.find((opt) => opt.language === (pdfLanguage || "Latvian"))
      if (langOpt) setSelectedTranslation(langOpt)

      setDocumentFor(deliveryMethod || "clientPickup")
      setDocForPrinting(customInvoice === false)
      checkTheClient(client || {})
    } else if (objectFromDrawer && fromDrawer) {
      //creates the array of prices
      const updatedPrices = objectFromDrawer.map((item) => ({
        ...item,
      }))

      //sets the client
      setInvoiceData((prevData) => ({
        ...prevData,
        client: extractedClient || {},
        clientId: extractedClient.id || null,
        prices: updatedPrices,
        manufacturer: extractedManufacturer || {},
      }))
    }
  }, [
    objectFromDrawer,
    fromDrawer,
    extractedClient,
    extractedManufacturer,
    editingInvoiceData,
    isEditing,
    form,
    documentTypeBasedOnDrawer, // showWeight (already a prop)
  ])

  // When editing, use fresh manufacturer data instead of old invoice data
  useEffect(() => {
    if (isEditing && extractedManufacturer && extractedManufacturer.id) {
      setInvoiceData((prevData) => ({
        ...prevData,
        manufacturer: extractedManufacturer,
      }))
    }
  }, [isEditing, extractedManufacturer])

  // Update form fields when client and manufacturer data are loaded from warehouse
  useEffect(() => {
    if (fromDrawer && extractedClient && extractedClient.client) {
      setTimeout(() => {
        form.setFieldsValue({
          client: extractedClient.client,
          manufacturer: extractedManufacturer?.company || "",
          receiverAddress: extractedClient.deliveryAddress || "",
        })
      }, 100)
    }
  }, [fromDrawer, extractedClient, extractedManufacturer, form])

  //updates delivery and receiver adresess
  useEffect(() => {
    let manufacturer

    if (invoiceData && invoiceData.manufacturer) {
      manufacturer =
        invoiceData.manufacturer.deliveryAddress +
        ", " +
        invoiceData.manufacturer.deliveryCity +
        ", " +
        invoiceData.manufacturer.deliveryPC
    }

    //sets the manufacturer when the invoice data changes
    setManufacturerDelivery([
      {
        deliveryAddress: manufacturer,
      },
    ])

    // When editing and fresh manufacturer data arrives, update the form field
    if (isEditing && manufacturer) {
      form.setFieldsValue({ pickupAddress: manufacturer })
    }
  }, [invoiceData, isEditing, form])

  //updates delivery address
  useEffect(() => {
    const client = invoiceData.client
    setDeliveryOptions([
      ...manufacturerDelivery, // also adds delivery to its own place
      {
        deliveryAddress: client.deliveryAddress,
      },
      {
        deliveryAddress: client.deliveryAddress2,
      },
    ])
  }, [invoiceData, manufacturerDelivery])

  //updates doc
  const updateClientData = async (data, object) => {
    //doc ref
    const ref = doc(db, "clients", data.id)
    //Approve the price
    await updateDoc(ref, object)
      .then(() => {
        message.success("Client information has been updated!")
      })
      .then(() => {
        setDrawerOpen(false)
        setClientKeysToUpdate({})
      })
      .catch((err) => {
        message.error(`Error : ${err.message}`)
      })
  }

  // handles the avaiable products
  // -- OLD WAY - caused bugs, queried by client.id
  useEffect(() => {
    setProductsLoading(true)
    let ref = collection(db, "priceCalculation")
    let q = query(ref, where("clientId", "==", invoiceData.client.id))
    //gets data with query
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ ...doc.data(), id: doc.id })
      })
      setAvailableProducts(results)
      setProductsLoading(false)
    })
    //executes function
    return () => unsubscribe()
  }, [invoiceData.client.id])

  //updates the information if there are or arent any keys to update
  useEffect(() => {
    //if there are no keys, sets to false, else true
    if (Object.keys(clientKeysToUpdate).length > 0) {
      setDoesClientNeedUpdated(true)
    } else {
      setDoesClientNeedUpdated(false)
    }
  }, [clientKeysToUpdate])

  //should a button be disabled
  useEffect(() => {
    const prices = Array.isArray(invoiceData?.prices) ? invoiceData.prices : []

    // invalid count (<= 0)
    const hasInvalidCount = prices.some((p) => Number(p?.count) <= 0)

    // missing/empty productType (null, undefined, "", "   ")
    const hasMissingType = prices.some((p) => !String(p?.productType || "").trim())

    setDisabledButton(!!doesClientNeedUpdate || hasInvalidCount || hasMissingType)
  }, [doesClientNeedUpdate, invoiceData?.prices])

  //handle document for
  const handleDocumentType = (value) => {
    setDocumentType(value)
  }

  //handle document for
  const handleDocumentFor = (value) => {
    // Instead of just console.log, update the state
    setInvoiceData((prevData) => ({
      ...prevData,
      documentFor: value,
    }))
    setDocumentFor(value)
  }

  //pay until date
  const handlePayUntilDate = (date) => {
    if (date) {
      const jsDate = date.toDate()
      const ts = Timestamp.fromDate(jsDate)
      const formatted = formatDate(jsDate)

      setInvoiceData((prev) => ({
        ...prev,
        payUntil: ts, // ← now a Timestamp
        // optional: keep the string just for display
        payUntilFormatted: formatted,
      }))
    } else {
      setInvoiceData((prevData) => ({
        ...prevData,
        payUntil: null,
        payUntilFormatted: "",
        payUntilTimestamp: null,
      }))
    }
  }

  //handles the date
  //if today is selected, it is an invoice
  //if tomorrow + is selected, then it is proforma
  const handleDateChange = (date, dateString) => {
    let formattedDate
    let firebaseDate

    if (date) {
      const selectedDate = date.toDate()
      firebaseDate = Timestamp.fromDate(selectedDate)
      formattedDate = selectedDate

      // const today = moment().startOf("day")
      // const tomorrow = moment().add(1, "day").startOf("day")

      // if (moment(selectedDate).isSame(today, "day")) {
      //   setDocumentType("invoice") // Update document type to invoice
      // } else if (
      //   moment(selectedDate).isAfter(today) ||
      //   moment(selectedDate).isSame(tomorrow, "day")
      // ) {
      //   setDocumentType("proforma") // Update document type to proforma
      // }
    } else {
      firebaseDate = Timestamp.fromDate(today)
      formattedDate = today
    }

    setInvoiceData((prevData) => ({
      ...prevData,
      documentDate: firebaseDate,
      pdfDate: formattedDate,
    }))
  }

  //handle comment change
  const handleCommentChange = (value) => {
    setInvoiceData((prevData) => ({
      ...prevData,
      commentText: value,
    }))
  }

  //disable yesterday
  //if admin, you can pick any date
  const disabledDate = (current) => {
    if (admin) {
      // Enable all dates if admin flag is true
      return false
    }
    // Disable dates before yesterday
    return current && current < moment().subtract(1, "days").endOf("day")
  }

  const onFinish = async ({
    payUntil,
    comment: formItemCommentValue,
    client: clientNameFromForm,
    manufacturer: manufacturerNameFromForm,
    documentForComment: formItemDocForCommentValue,
    creditInvoiceId,
    ...otherValues
  }) => {
    const jsDate = payUntil.toDate()
    const payUntilTs = Timestamp.fromDate(jsDate)

    const currentMainComment = typeof formItemCommentValue === "string" ? formItemCommentValue : ""
    const currentLogisticsComment =
      typeof formItemDocForCommentValue === "string" ? formItemDocForCommentValue : ""

    let processedPrices = invoiceData.prices.map((priceItem) => {
      let baseComment = ""
      if (typeof priceItem.rawComment === "string") {
        baseComment = priceItem.rawComment.trim()
      } else if (typeof priceItem.productComment === "string") {
        baseComment = getBaseComment(priceItem.productComment, priceItem.weight)
      }
      baseComment = String(baseComment || "").trim()

      let finalProductComment = baseComment
      if (props.showWeight && priceItem.weight > 0) {
        const weightString = `${Number(priceItem.weight).toFixed(2)} kg`
        finalProductComment = baseComment ? `${baseComment} | ${weightString}` : weightString
      }

      return {
        ...priceItem,
        productComment: finalProductComment.trim(),
        hasProductComment: Boolean(finalProductComment.trim()),
        rawComment: baseComment,
      }
    })

    if (totalsData.totalProfitDiscount !== 0) {
      const discountLine = {
        key: processedPrices.length + 1,
        code: 0,
        product: totalsData.totalProfitDiscount > 0 ? "Surcharge" : "Discount", // ✅ English
        productType: "",
        unit: "pcs.",
        count: 1,
        price: totalsData.totalProfitDiscount,
        sum: totalsData.totalProfitDiscount,
        vat: parseFloat((totalsData.totalProfitDiscount * 0.21).toFixed(2)),
        // Latvian accounting entries
        dAccount: totalsData.totalProfitDiscount > 0 ? 2310 : 6410,
        dName:
          totalsData.totalProfitDiscount > 0
            ? "Norēķini ar pircējiem un pasūtītājiem"
            : "Pārdošanas atlaides",
        dCurrency: "Eur",
        cAccount: totalsData.totalProfitDiscount > 0 ? 6110 : 2310,
        cName:
          totalsData.totalProfitDiscount > 0
            ? "Ieņēmumi no pamatdarbības produkcijas un pakalpojumu pārdošanas"
            : "Norēķini ar pircējiem un pasūtītājiem",
        kCurrency: "Eur",
        productComment: "",
        hasProductComment: false,
        hasManualCount: false,
        hasChangableSpace: false,
        rawComment: "",
      }
      processedPrices.push(discountLine)
    }

    const payload = {
      ...invoiceData,
      ...otherValues,

      clientsCompanyAddress: form.getFieldValue("clientsCompanyAddress") || null,

      client: invoiceData.client,
      manufacturer: invoiceData.manufacturer,

      commentText: currentMainComment,
      documentForComment: currentLogisticsComment,

      payUntil: payUntilTs,
      payUntilFormatted: formatDate(jsDate),

      clientDeliveryAddress:
        form.getFieldValue("receiverAddress") || invoiceData.clientDeliveryAddress,
      manufacturerDeliveryAddress:
        form.getFieldValue("pickupAddress") || invoiceData.manufacturerDeliveryAddress,

      prices: processedPrices,
      totalData: totalsData,
      pdfLanguage: selectedLanguage,
      docType: documentType,
      deliveryMethod: documentFor,
      customInvoice: !docForPrinting,

      user: isEditing ? editingInvoiceData?.user || user.email : user.email,
      userId: isEditing ? editingInvoiceData?.userId || user.uid : user.uid,

      documentDate: Timestamp.fromDate(form.getFieldValue("invoiceDate").toDate()),
      pdfDate: form.getFieldValue("invoiceDate").toDate(),
      invoiceDate: form.getFieldValue("invoiceDate").toDate(),

      // Store selected bank account indices for re-generation during edits
      selectedManufacturerBankAccountIndex,
      selectedClientBankAccountIndex,

      // Add credit invoice data conditionally INSIDE the payload object
      ...(isCreditInvoice &&
        selectedCreditInvoice && {
          isCreditInvoice: true,
          creditInvoiceData: creditInvoiceData,
        }),
    }

    console.log(payload)

    // Handle showWeightInComment
    if (showWeight) {
      payload.showWeightInComment = true
    } else {
      if (isEditing) {
        payload.showWeightInComment = deleteField()
      } else {
        delete payload.showWeightInComment
      }
    }

    if (isEditing) {
      if (payload.docType === "invoice") {
        handleUpdateInvoice(payload)
      } else if (payload.docType === "proforma") {
        message.info("Proforma update called (using invoice logic for now).")
        handleUpdateInvoice(payload)
      }
      if (editingInvoiceData.isCreditInvoice && editingInvoiceData.creditInvoiceData) {
        setIsCreditInvoice(true)
        setSelectedCreditInvoice(editingInvoiceData.creditInvoiceData.creditInvoiceId)
        setCreditInvoiceData(editingInvoiceData.creditInvoiceData)

        form.setFieldsValue({
          creditInvoiceId: editingInvoiceData.creditInvoiceData.creditInvoiceId,
        })
      }
    } else {
      if (documentType === "invoice") {
        createInvoice(payload)
      } else {
        createProforma(payload)
      }
    }
  }

  //if form fails
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //updateClient form action
  const onClientUpdateFormFinish = (values) => {
    console.log("Success:", values)
    updateClientData(invoiceData.client, values)
    updateClientForm.resetFields()
  }

  const onClientUpdateFormFailed = (errorInfo) => {
    message.error("error: Please fill out the fields!")
  }

  //handles client select
  const handleClientSelect = (value, options) => {
    setInvoiceData((prevData) => ({
      ...prevData,
      client: options,
      clientId: options.id,
      manufacturer: options.manufacturer || prevData.manufacturer,
      prices: [
        {
          key: 1,
          code: 0,
          product: null,
          unit: "thous.",
          count: 0,
          price: 0.0,
          sum: 0,
          vat: 0,
          dAccount: 2310,
          dName: "Norēķini ar pircējiem un pasūtītājiem",
          dCurrency: "Eur",
          cAccount: 6110,
          cName: "Ieņēmumi no pamatdarbības produkcijas un pakalpojumu pārdošanas",
          kCurrency: "Eur",
          productComment: "",
          hasProductComment: false,
          hasManualCount: false,
          hasChangableSpace: false,
          weight: 0,
        },
      ],
    }))

    // Update the form fields accordingly.
    form.setFieldsValue({
      client: options.client,
      manufacturer: options.manufacturer ? options.manufacturer.company : "",
    })

    //calls the checker function to see if client needs updating
    checkTheClient(options)

    //resets the fields on form
    form.resetFields(["receiverAddress"])
  }

  //handles manufacturer
  const handleManufacturer = (value, options) => {
    setInvoiceData((prevData) => ({
      ...prevData,
      manufacturer: options,
    }))
  }

  //handles client address
  const handleClientDeliveryAddress = (value) => {
    setInvoiceData((prevData) => ({
      ...prevData,
      clientDeliveryAddress: value,
    }))
  }

  //handles manfuacturer address
  const handleManufacturerAddress = (value, options) => {
    setInvoiceData((prevData) => ({
      ...prevData,
      manufacturerDeliveryAddress: options.deliveryAddress,
    }))
  }

  //handles language select
  const handleLanguageSelect = (value, options) => {
    setSelectedTranslation(options)
    setSelectedLanguage(value)
  }

  // If the user changes the text in the new text area:
  const handleDocumentForCommentChange = (e) => {
    const value = e.target.value
    setInvoiceData((prev) => ({
      ...prev,
      documentForComment: value,
    }))
  }

  //Tabs
  //first tab
  const goodsAndServices = () => {
    let initialRowCount = 0
    if (isEditing && editingInvoiceData?.prices) {
      // In EDIT mode, the count is the number of prices on the invoice being edited
      initialRowCount = editingInvoiceData.prices.length
    } else if (fromDrawer && selectedRowKeys) {
      // When CREATING from orders, the count is the number of selected rows
      initialRowCount = selectedRowKeys.length
    }

    return (
      <div>
        <Row gutter={[15, 15]}>
          <Col span={24}>
            <ProductsAndServices
              setTotalsData={setTotalsData}
              productsLoading={productsLoading}
              availableProducts={availableProducts}
              invoiceData={invoiceData}
              setInvoiceData={setInvoiceData}
              count={count}
              setCount={setCount}
              disabledInitialRowsCount={initialRowCount}
              setProductCounts={setProductCounts}
              productCount={productCount}
              fromDrawer={fromDrawer}
              objectFromDrawer={objectFromDrawer}
              docForPrinting={docForPrinting}
              forProforma={forProforma}
              showWeight={showWeight}
            />
          </Col>
        </Row>
      </div>
    )
  }

  //drawer
  const onDrawerClose = () => {
    setDrawerOpen(false)
  }

  //snould or shouldnt return global loading
  const returnGlobalLoading = () => {
    if (globalLoading) {
      return <>{loadingSpinWithBg(75, "Generating document...")}</>
    }
  }

  //drawer content
  //takes the empty keys as argument
  const returnClientDrawer = (objectData) => {
    return (
      <>
        {returnGlobalLoading()}
        <Drawer
          title="Update client data"
          placement="left"
          open={drawerOpen}
          onClose={onDrawerClose}>
          <Form
            form={updateClientForm}
            name="updateClientForm"
            initialValues={{
              remember: true,
            }}
            layout="vertical"
            onFinish={onClientUpdateFormFinish}
            onFinishFailed={onClientUpdateFormFailed}
            autoComplete="off"
            style={{ width: "100%" }}>
            {Object.entries(objectData).map(([key, value]) => (
              <div key={key} style={{ marginBottom: 10 }}>
                {returnProperLayour(key)}
              </div>
            ))}
            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Update Client
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </>
    )
  }

  //function that checks if there are any null keys
  const checkTheClient = (data) => {
    //keys that are required to check for
    const requiredKeys = [
      "accountant",
      "accountantEmail",
      "accountantNumber",
      "deliveryAddress",
      "deliveryAddress2",
      "bankName",
      "bankCode",
      "accountNumber",
    ]
    //checks if the key exists or its null
    const keysToUpdate = requiredKeys.filter(
      (key) => !data.hasOwnProperty(key) || data[key] === null,
    )

    //registers all the keys that should be updated insdie state
    setClientKeysToUpdate(
      keysToUpdate.reduce((obj, key) => {
        obj[key] = data[key]
        return obj
      }, {}),
    )
  }

  //returns the proper layout on the drawer
  const returnProperLayour = (key) => {
    switch (key) {
      case "accountant":
        return (
          <>
            <Divider>Accounting Info</Divider>

            <Form.Item
              label="Accountant Name :"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input accountant name",
                },
              ]}>
              <Input placeholder="Juris Gramatvedis" />
            </Form.Item>
          </>
        )

      case "accountantEmail":
        return (
          <>
            <Form.Item
              label="Accountant Email"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input email address",
                },
              ]}>
              <Input placeholder="gramatvede@test.lv" />
            </Form.Item>
          </>
        )
      case "accountantNumber":
        return (
          <>
            <Form.Item
              label="Accountant Phone Number :"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input accountant phone number",
                },
              ]}>
              <Input placeholder="+371 254343444" />
            </Form.Item>
          </>
        )
      case "deliveryAddress":
        return (
          <>
            <Divider>Delivery Info</Divider>
            <Form.Item
              label="Delivery Address"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input delivery address",
                },
              ]}>
              <Input placeholder="Pernavas iela 55, Riga, LV-1009" />
            </Form.Item>
          </>
        )
      case "deliveryAddress2":
        return (
          <>
            <Form.Item
              label="Delivery Address 2"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input second delivery address or write the same",
                },
              ]}>
              <Input placeholder="Pernavas iela 55, Riga, LV-1009" />
            </Form.Item>
          </>
        )
      case "bankName":
        return (
          <>
            <Divider>Bank Info</Divider>
            <Form.Item
              label="Bank Name :"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input bank name",
                },
              ]}>
              <Input placeholder="AS `Swedbank`" />
            </Form.Item>
          </>
        )
      case "bankCode":
        return (
          <>
            <Form.Item
              label="Bank Code :"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input bank code",
                },
              ]}>
              <Input placeholder="HABALV20" />
            </Form.Item>
          </>
        )
      case "accountNumber":
        return (
          <>
            <Form.Item
              label="Bank Account Number"
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input bank account number",
                },
              ]}>
              <Input placeholder="LV16HABA0552054382294" />
            </Form.Item>
          </>
        )
      default:
        return (
          <>
            <Form.Item
              label={key}
              name={key}
              rules={[
                {
                  required: true,
                  message: "Please input something here!",
                },
              ]}>
              <Input />
            </Form.Item>
          </>
        )
    }
  }

  //returns correct button based if client needs needs to be updated
  const returnCorrectClientButton = () => {
    if (doesClientNeedUpdate) {
      return (
        <div style={{ marginTop: 5 }}>
          <Space align="start">
            <InfoCircleOutlined style={{ color: "#f5222d" }} />
            <Text>
              This client needs to be updated. If it's details will not be updated you wont be able
              to create your invoice!
              <Button block type="primary" danger onClick={() => setDrawerOpen(true)}>
                Update now
              </Button>
            </Text>
          </Space>
        </div>
      )
    }
  }

  //tabs items
  const tabItems = [
    {
      key: 1,
      label: "Products & Services",
      children: goodsAndServices(),
    },
  ]

  //styles
  //top row
  const topRowItemsStyle = {
    width: 200,
  }
  //left second row
  const leftSecondRow = {
    margin: 0,
  }

  //select style
  const selectStyle = {
    width: "100%",
  }

  // Filter out null delivery addresses from deliveryOptions
  const filteredDeliveryOptions = deliveryOptions.filter(
    (delivery) => delivery.deliveryAddress !== null,
  )

  // Filter out null delivery addresses from deliveryOptions
  const filteredManufacturerDelivery = manufacturerDelivery.filter(
    (delivery) => delivery.deliveryAddress !== null,
  )

  //handles change for choosing what for document is
  const handleWhatForDocument = (value) => {
    setDocForPrinting(value)
  }

  const handleUpdateInvoice = async (updatedInvoiceObject) => {
    setGloabalLoading(true)
    const invoiceId = updatedInvoiceObject.id // This is the ID of the invoice being edited

    if (!invoiceId) {
      message.error("Cannot update: Invoice ID is missing.")
      setGloabalLoading(false)
      return
    }

    const mainInvoiceRef = doc(db, "invoices", invoiceId) // Assuming "invoices" is your main collection
    const archiveCollectionRef = collection(db, "archivedInvoices") // Your new archive collection

    try {
      // Step 1: Fetch the current (original) invoice document that will be archived
      const originalInvoiceSnap = await getDoc(mainInvoiceRef)
      if (!originalInvoiceSnap.exists()) {
        throw new Error("Original invoice document not found to archive.")
      }
      const originalInvoiceDataToArchive = originalInvoiceSnap.data()

      // Step 2: Save the original data to the archive collection
      // This archive entry will contain the state of the invoice *before* the current edit,
      // including its then-current downloadUrl.
      const archiveData = {
        ...originalInvoiceDataToArchive,
        originalInvoiceId: invoiceId, // Reference to the live invoice ID it's a version of
        archivedAt: serverTimestamp(),
        archivedBy: user.uid, // User who triggered the edit that led to this archival
      }
      const archiveDocRef = await addDoc(archiveCollectionRef, archiveData)
      console.log("Invoice version archived with ID:", archiveDocRef.id)

      // Step 3: Prepare data for PDF regeneration (using original immutable identifiers from editingInvoiceData)
      // It's important that `editingInvoiceData` props are used for fixed identifiers like docNumber
      // and `updatedInvoiceObject` for the content that might have changed in the form.
      const pdfData = {
        ...updatedInvoiceObject, // Contains current form data (potentially edited fields)
        docNumber: editingInvoiceData.docNumber, // !!! USE ORIGINAL from when form loaded for editing
        hronodId: editingInvoiceData.hronodId, // !!! USE ORIGINAL
        docPrefix: editingInvoiceData.docPrefix, // !!! USE ORIGINAL
        user: editingInvoiceData.user, // !!! Original user who created it
        userId: editingInvoiceData.userId, // !!! Original userId
        totalData: totalsData, // Current calculated totals
        pdfLanguage: selectedLanguage,
        manufacturer: {
          // Ensure manufacturer object is complete with a valid logoUrl
          ...(updatedInvoiceObject.manufacturer || {}),
          logoUrl:
            updatedInvoiceObject.manufacturer?.logoUrl ||
            editingInvoiceData.manufacturer?.logoUrl || // Fallback to originally loaded data
            "https://firebasestorage.googleapis.com/v0/b/managers-testing.appspot.com/o/manufacturers%2FdefaultLogo.png?alt=media&token=bdbe0c13-2de9-4be7-bc80-be8fd7e0f82a", // Your ultimate fallback
        },
        client: {
          // Ensure client object is complete if generateInvoice relies on its structure
          ...(updatedInvoiceObject.client || {}),
        },
      }

      // Step 4: Generate New PDF for the current edits
      const newPdfUrl = await generateInvoice(
        pdfData,
        selectedLanguage,
        selectedTranslation,
        "invoice", // docType is fixed for this function
        hasProformas,
        proformasData,
        false,
        {},
        selectedManufacturerBankAccountIndex,
        selectedClientBankAccountIndex,
      )

      if (!newPdfUrl) {
        throw new Error("Failed to re-generate PDF for update.")
      }

      // Step 5: Prepare data for updating the live invoice document
      const firestoreUpdateData = {
        ...updatedInvoiceObject, // All current (edited) form data
        downloadUrl: newPdfUrl, // The NEW PDF URL
        // Ensure date conversions for Firestore
        pdfDate: Timestamp.fromDate(updatedInvoiceObject.pdfDate), // pdfDate in updatedInvoiceObject should be a JS Date
        documentDate: Timestamp.fromDate(updatedInvoiceObject.documentDate.toDate()), // If dayjs obj from form
        payUntil: updatedInvoiceObject.payUntil, // Should be a Timestamp
        invoiceDate: Timestamp.fromDate(updatedInvoiceObject.invoiceDate), // If dayjs obj from form

        prices: updatedInvoiceObject.prices.map((p) => ({
          ...p,
          sum: Number(p.sum.toFixed(3)),
        })),
        totalData: totalsData,
        pdfLanguage: selectedLanguage,
        lastUpdated: serverTimestamp(),
        lastUpdatedBy: user.uid, // User performing the current edit
        showWeightInComment: showWeight,

        // Add reference to the archived version
        previousVersionId: archiveDocRef.id,
        // Optionally, if you want a running list of all previous versions:
        // versionHistory: arrayUnion(archiveDocRef.id) // Make sure 'versionHistory' is an array
      }

      // Remove fields that should NOT be changed by an update from the live record
      // These are inherent properties of the invoice that define its original identity.
      delete firestoreUpdateData.docNumber
      delete firestoreUpdateData.docPrefix
      delete firestoreUpdateData.hronodId
      delete firestoreUpdateData.user // Keep the original creator on the main doc
      delete firestoreUpdateData.userId // Keep the original creator's ID on the main doc
      delete firestoreUpdateData.createdTimestamp // Original creation timestamp
      // orderReferenceId and proformaReferenceIds are typically fixed unless specifically part of the edit.
      // If they are not meant to be changed, ensure they are also removed or taken from editingInvoiceData.
      // For now, assuming updatedInvoiceObject (from payload) correctly reflects if they *were* editable and changed.
      // If not, you might do:
      // firestoreUpdateData.orderReferenceId = editingInvoiceData.orderReferenceId;

      // Step 6: Update the main (live) invoice document
      await updateDoc(mainInvoiceRef, firestoreUpdateData)

      // Step 7: Update linked orders with the NEW PDF URL (if applicable)
      if (
        editingInvoiceData.orderReferenceId &&
        editingInvoiceData.orderReferenceId.length > 0 &&
        !firestoreUpdateData.customInvoice // Only for non-custom, "printing" invoices
      ) {
        const orderUpdatePromises = editingInvoiceData.orderReferenceId.map((orderId) => {
          const orderRef = doc(db, "orders", orderId)
          return updateDoc(orderRef, {
            "invoice.invoiceUrl": newPdfUrl,
            "invoice.updated": serverTimestamp(),
          })
        })
        await Promise.all(orderUpdatePromises)
      }

      // Step 8: Handle Packing List & Email (if applicable, using newPdfUrl)
      if (firestoreUpdateData.documentFor === "warehouseLogistics") {
        try {
          const packingListURL = await createAndSavePackingList() // This creates a new PL

          if (
            editingInvoiceData.orderReferenceId &&
            editingInvoiceData.orderReferenceId.length > 0
          ) {
            const plOrderPromises = editingInvoiceData.orderReferenceId.map((id) => {
              const orderRef = doc(db, "orders", id)
              return updateDoc(orderRef, {
                hasPackingList: true,
                packingListUrl: packingListURL,
                updated: serverTimestamp(),
              })
            })
            await Promise.all(plOrderPromises)
          }

          const emailFunctionUrl =
            "https://us-central1-managers-testing.cloudfunctions.net/sendDocsEmail"
          const emailResponse = await fetch(emailFunctionUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              invoiceUrl: newPdfUrl,
              packingListUrl: packingListURL,
              contactEmail: firestoreUpdateData.client?.contactEmail || "reinis.putans@gmail.com",
            }),
          })
          if (!emailResponse.ok) console.error("Failed to send update email via Cloud Function")
          else message.success("Email with updated documents sent!")
        } catch (plError) {
          console.error("Error handling packing list during invoice update:", plError)
          message.error("Failed to update/send packing list documents.")
        }
      }

      message.success("Invoice updated successfully! Previous version archived.")
      if (onSuccess) onSuccess(true) // Notify parent to refresh or close
    } catch (error) {
      message.error(`Error updating invoice: ${error.message}. Please check console.`)
      console.error("Update Invoice Error:", error)
    } finally {
      setGloabalLoading(false)
    }
  }
  // You would create a similar `handleUpdateProforma` if proformas are editable.

  //sets the default pickup address
  useEffect(() => {
    if (filteredManufacturerDelivery.length > 0) {
      const defaultValue = filteredManufacturerDelivery[0].deliveryAddress

      // Check if the current invoiceData already has the default manufacturerDeliveryAddress
      // to avoid unnecessary state updates.
      if (invoiceData.manufacturerDeliveryAddress !== defaultValue) {
        setInvoiceData((prevData) => ({
          ...prevData,
          manufacturerDeliveryAddress: defaultValue,
        }))

        // Assuming you still need to update the form field to reflect this change.
        form.setFieldsValue({ pickupAddress: defaultValue })
      }
    }
  }, [filteredManufacturerDelivery, form, invoiceData.manufacturerDeliveryAddress])

  return (
    <>
      <Form
        name="myForm"
        initialValues={{
          remember: true,
          documentFor: "clientPickup",
          invoiceDate: dayjs(),
          payUntil: dayjs(twoWeeksTs.toDate()),
          language: "Latvian",
          comment: "",
          whatForDoc: fromDrawer ? true : false,
          docType: forProforma ? "proforma" : "invoice",
        }}
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        style={{ width: "100%" }}>
        <Row gutter={[15, 15]}>
          <Col span={24}>
            <Space>
              <Text>Document Type :</Text>
              <Tag color="blue">{documentType}</Tag>
            </Space>
          </Col>
          {isEditing && editingInvoiceData && (
            <Col span={24}>
              <Text strong>
                Invoice Nr: {editingInvoiceData.docPrefix}
                {String(editingInvoiceData.docNumber).padStart(4, "0")}
              </Text>
            </Col>
          )}
          <Col span={4}>
            <Form.Item label="Document Type" name="docType" className="custom-form-item">
              <Select
                onChange={handleDocumentType}
                options={[
                  { value: "proforma", label: "Proforma" },
                  { value: "invoice", label: "Invoice" },
                ]}
                style={topRowItemsStyle}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="For"
              name="whatForDoc"
              rules={[
                {
                  required: false,
                  message: "Please select a date!",
                },
              ]}
              className="custom-form-item">
              <Select
                disabled={fromDrawer}
                onChange={handleWhatForDocument}
                options={[
                  { value: true, label: "Printing", disabled: !fromDrawer },
                  { value: false, label: "Custom" },
                ]}
                style={topRowItemsStyle}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Document Date"
              name="invoiceDate"
              rules={[
                {
                  required: true,
                  message: "Please select a date!",
                },
              ]}
              className="custom-form-item">
              <DatePicker
                format="DD.MM.YYYY"
                disabledDate={disabledDate}
                onChange={handleDateChange}
                placeholder="Select a date"
                style={topRowItemsStyle}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Payment Until"
              name="payUntil"
              rules={[
                {
                  required: true,
                  message: "Please select a date!",
                },
              ]}
              className="custom-form-item">
              <DatePicker
                format="DD.MM.YYYY"
                disabledDate={(current) => {
                  // If there's no documentDate, allow all dates.
                  if (!invoiceData.documentDate) return false
                  // Otherwise, disable dates before documentDate (startOf the day)
                  return current && current < moment(invoiceData.documentDate).startOf("day")
                }}
                onChange={handlePayUntilDate}
                placeholder="Select a date"
                style={topRowItemsStyle}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Currency"
              name="currency"
              initialValue="Eur"
              rules={[
                {
                  required: true,
                  message: "Please select a currency!",
                },
              ]}
              wrapperCol={{ span: 12 }}
              className="custom-form-item"
              colon={false} // This removes the colon after the label
            >
              <Select style={topRowItemsStyle} options={[{ value: "Eur", label: "Eur" }]} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Language"
              name="language"
              rules={[
                {
                  required: true,
                  message: "Please select invoice language",
                },
              ]}
              wrapperCol={{ span: 12 }}
              className="custom-form-item"
              colon={false} // This removes the colon after the label
            >
              <Select
                style={topRowItemsStyle}
                value={selectedLanguage}
                onChange={handleLanguageSelect}
                fieldNames={{ label: "language", value: "language" }}
                options={languageOpts}
                placeholder="Select Language"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <div style={{ padding: 25, background: "white", borderRadius: 6, width: "100%" }}>
              <Divider orientation="left">
                <Space>
                  <UserOutlined />
                  Client
                </Space>
              </Divider>
              <Row gutter={[15, 15]}>
                <Col span={24}>
                  <Form.Item
                    label="Client"
                    name="client"
                    rules={[
                      {
                        required: true,
                        message: "Please select the client!",
                      },
                    ]}
                    style={leftSecondRow}
                    colon={false} // This removes the colon after the label
                  >
                    <Select
                      // disabled={fromDrawer}
                      showSearch
                      style={selectStyle}
                      onChange={handleClientSelect}
                      fieldNames={{ label: "client", value: "client" }}
                      options={clientData}
                      loading={clientLoading}
                      value={invoiceData.client}
                    />
                  </Form.Item>
                </Col>
                {invoiceData.client.client !== "none" &&
                  getAvailableBankAccounts(invoiceData.client).length > 1 && (
                    <Col span={24}>
                      <Form.Item
                        label="Client Bank Account"
                        style={leftSecondRow}
                        colon={false}>
                        <Select
                          value={selectedClientBankAccountIndex}
                          onChange={setSelectedClientBankAccountIndex}
                          options={getAvailableBankAccounts(invoiceData.client)}
                        />
                      </Form.Item>
                    </Col>
                  )}
                {returnCorrectClientButton()}
                {isEditing && (
                  <Col span={24}>
                    <Form.Item
                      label="Client's Legal Address"
                      name="clientsCompanyAddress"
                      rules={[
                        {
                          required: true,
                          message: "Please provide the client's company address!",
                        },
                      ]}
                      style={leftSecondRow}
                      colon={false}>
                      <Input
                        placeholder="e.g., Brīvības iela 1, Rīga, LV-1010"
                        onChange={(e) =>
                          setInvoiceData((prev) => ({
                            ...prev,
                            clientsCompanyAddress: e.target.value,
                          }))
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col span={24}>
                  <Form.Item
                    label="Receiver address"
                    name="receiverAddress"
                    rules={[
                      {
                        required: true,
                        message: "Please select receivers address!",
                      },
                    ]}
                    style={leftSecondRow}
                    colon={false} // This removes the colon after the label
                  >
                    {isEditing ? (
                      <Input
                        placeholder="Enter delivery address manually"
                        // Value is managed by Form.Item via 'name' prop.
                        // onChange updates your component's state.
                        onChange={(e) => handleClientDeliveryAddress(e.target.value)}
                        // This Input will be enabled by default unless you add a 'disabled' prop.
                      />
                    ) : (
                      <Select
                        // style={selectStyle} // Your existing style
                        options={filteredDeliveryOptions} // Make sure this is correctly populated
                        placeholder="Select delivery address"
                        fieldNames={{ label: "deliveryAddress", value: "deliveryAddress" }}
                        // When creating (not editing), disable if no options or if client info
                        // is pre-determined from selected orders (fromDrawer might be true).
                        disabled={filteredDeliveryOptions.length === 0}
                        onChange={(value) => handleClientDeliveryAddress(value)} // Pass only the value
                      />
                    )}
                  </Form.Item>
                  <Text>
                    Need a new product? <Link href="/calculations">Create one.</Link>
                  </Text>
                </Col>

                <Col span={24}>
                  <Form.Item
                    label="Comment"
                    name="comment"
                    colon={false} // This removes the colon after the label
                  >
                    <TextArea
                      onChange={(event) => handleCommentChange(event.target.value)}
                      rows={3}
                      style={{ resize: "none", width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Divider />
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Checkbox
                      checked={isCreditInvoice}
                      onChange={(e) => handleCreditInvoiceToggle(e.target.checked)}
                      disabled={documentType === "proforma"} // Credit invoices only work for invoices
                    >
                      This is a <Text strong>Credit Invoice</Text> (deduct from previous invoice)
                    </Checkbox>

                    {isCreditInvoice && (
                      <Form.Item
                        label="Select Invoice to Credit"
                        name="creditInvoiceId"
                        rules={[
                          {
                            required: isCreditInvoice,
                            message: "Please select an invoice to credit!",
                          },
                        ]}
                        style={{ marginBottom: 0 }}>
                        <Select
                          showSearch
                          placeholder="Select an invoice..."
                          loading={loadingInvoices}
                          options={availableInvoices}
                          onChange={handleCreditInvoiceSelect}
                          filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    )}

                    {selectedCreditInvoice && creditInvoiceData.creditInvoiceCode && (
                      <Alert
                        message={`Credit Reference: ${creditInvoiceData.creditInvoiceCode}`}
                        description={`Original Amount: ${creditInvoiceData.creditInvoiceTotalSum.toFixed(
                          2,
                        )} EUR (Neto: ${creditInvoiceData.creditInvoiceTotalNeto.toFixed(
                          2,
                        )} EUR + VAT: ${creditInvoiceData.creditInvoiceTotalVat.toFixed(2)} EUR)`}
                        type="info"
                        showIcon
                      />
                    )}
                  </Space>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Checkbox
                    style={{ margin: "12px 0" }}
                    checked={showWeight}
                    onChange={(e) => setShowWeight(e.target.checked)}>
                    Show product weight in comments
                  </Checkbox>
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={12}>
            <div style={{ padding: 25, background: "white", borderRadius: 6, width: "100%" }}>
              <Divider orientation="left">
                <Space>
                  <PieChartOutlined />
                  Manufacturer
                </Space>
              </Divider>
              <Row gutter={[15, 15]}>
                <Col span={24}>
                  <Form.Item
                    label="Manufacturer"
                    name="manufacturer"
                    rules={[
                      {
                        required: true,
                        message: "Please select the manufacturer!",
                      },
                    ]}
                    style={leftSecondRow}
                    colon={false} // This removes the colon after the label
                  >
                    <Select
                      disabled={fromDrawer}
                      loading={manufacturerLoading}
                      style={selectStyle}
                      onChange={handleManufacturer}
                      fieldNames={{ label: "company", value: "company" }}
                      options={manufacturerData}
                    />
                  </Form.Item>
                </Col>
                {invoiceData.manufacturer.company !== "none" &&
                  getAvailableBankAccounts(invoiceData.manufacturer).length > 1 && (
                    <Col span={24}>
                      <Form.Item
                        label="Manufacturer Bank Account"
                        style={leftSecondRow}
                        colon={false}>
                        <Select
                          value={selectedManufacturerBankAccountIndex}
                          onChange={setSelectedManufacturerBankAccountIndex}
                          options={getAvailableBankAccounts(invoiceData.manufacturer)}
                        />
                      </Form.Item>
                    </Col>
                  )}
                <Col span={24}>
                  <Form.Item
                    label="Pickup address"
                    name="pickupAddress"
                    rules={[
                      {
                        required: true,
                        message: "Please select the pickup address!",
                      },
                    ]}
                    style={
                      invoiceData.manufacturer.company === "none"
                        ? { display: "none" }
                        : leftSecondRow
                    }
                    colon={false} // This removes the colon after the label
                  >
                    <Select
                      fieldNames={{ label: "deliveryAddress", value: "deliveryAddress" }}
                      style={selectStyle}
                      disabled={filteredManufacturerDelivery.length === 0}
                      options={filteredManufacturerDelivery}
                      onChange={handleManufacturerAddress}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Document for"
                    name="documentFor"
                    rules={[
                      {
                        required: true,
                        message: "Please select the document destination!",
                      },
                    ]}
                    style={leftSecondRow}
                    colon={false} // This removes the colon after the label
                  >
                    <Select
                      style={selectStyle}
                      options={[
                        {
                          value: "clientPickup",
                          label: "Simple Pickup",
                        },
                        {
                          value: "warehouseLogistics",
                          label: "Logistics Pickup for Warehouse",
                          disabled: documentType === "invoice" ? false : true,
                        },
                        {
                          value: "ourDilvery",
                          label: "Our Delivery",
                        },
                      ]}
                      onChange={handleDocumentFor}
                    />
                  </Form.Item>
                </Col>
                {invoiceData.documentFor === "warehouseLogistics" && (
                  <Col span={24}>
                    <Form.Item label="Logistics Comment" name="documentForComment" colon={false}>
                      <TextArea
                        rows={2}
                        style={{ resize: "none", width: "100%" }}
                        onChange={handleDocumentForCommentChange}
                        value={invoiceData.documentForComment}
                      />
                    </Form.Item>
                    <Paragraph style={{ marginTop: -15, color: "#f5222d" }} italic>
                      Packing list will be sent email to : {extractedClient.contactEmail}
                    </Paragraph>
                  </Col>
                )}
              </Row>
            </div>
          </Col>

          <Col span={24}>
            <Tabs animated={false} defaultActiveKey="1" size="small" items={tabItems} />
          </Col>
          <Col span={24}>
            {hasProformas ? (
              <Text type="danger">
                This document will have a refference to proforma. The proforma will show up in
                invoice creation.
              </Text>
            ) : (
              ""
            )}
          </Col>
          <Space>
            <Form.Item>
              <Button icon={<EyeOutlined />} type="default" onClick={previewDocument}>
                Preview {documentType}
              </Button>
            </Form.Item>

            <Form.Item>
              <Button type="primary" disabled={disabledButton} htmlType="submit">
                {isEditing ? `Update ${documentType}` : `Create ${documentType}`}
              </Button>
            </Form.Item>
          </Space>
        </Row>
      </Form>
      {/* <Button style={{ backgroundColor: "#13c2c2", color: "#fff" }} onClick={testPackingList}>
        Test Packing List
      </Button> */}
      {returnClientDrawer(clientKeysToUpdate)}
    </>
  )
}
